const IMG = {
  flex: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwcHJpbnRpbmclMjBzaG9wJTIwcG9zdGVyJTIwYmFubmVyJTIwZmxleCUyMG1hY2hpbmV8ZW58MHx8fHwxNzg1ODYwMDM2fDA&ixlib=rb-4.1.0&q=85",
  vinyl: "https://images.unsplash.com/photo-1693031630146-568e2f72db0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwcHJpbnRpbmclMjBzaG9wJTIwcG9zdGVyJTIwYmFubmVyJTIwZmxleCUyMG1hY2hpbmV8ZW58MHx8fHwxNzg1ODYwMDM2fDA&ixlib=rb-4.1.0&q=85",
  sunboard: "https://images.unsplash.com/photo-1571217748526-261477b6ac62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxuZW9uJTIwc2lnbiUyMGJvYXJkJTIwc3RvcmUlMjBmcm9udHxlbnwwfHx8fDE3ODE5MDQxOTV8MA&ixlib=rb-4.1.0&q=85",
  led: "https://images.pexels.com/photos/5549643/pexels-photo-5549643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    id: "flex",
    img: IMG.flex,
    icon: "Layers",
    name_en: "Flex Printing",
    name_kn: "ಫ್ಲೆಕ್ಸ್ ಪ್ರಿಂಟಿಂಗ್",
    desc_en: "High-resolution frontlit & star flex banners for shops, events and hoardings. Same-day output.",
    desc_kn: "ಅಂಗಡಿ, ಈವೆಂಟ್ ಮತ್ತು ಹೋರ್ಡಿಂಗ್‌ಗಳಿಗೆ ಉನ್ನತ ಗುಣಮಟ್ಟದ ಫ್ಲೆಕ್ಸ್ ಬ್ಯಾನರ್. ಅದೇ ದಿನ.",
    price_en: "from ₹12/sq.ft",
    price_kn: "₹12/sq.ft ರಿಂದ",
  },
  {
    id: "vinyl",
    img: IMG.vinyl,
    icon: "Sticker",
    name_en: "Vinyl Printing",
    name_kn: "ವಿನೈಲ್ ಪ್ರಿಂಟಿಂಗ್",
    desc_en: "Self-adhesive stickers, glass branding, one-way vision and frosted film in matte or gloss.",
    desc_kn: "ಸ್ಟಿಕ್ಕರ್, ಗ್ಲಾಸ್ ಬ್ರ್ಯಾಂಡಿಂಗ್, ಒನ್-ವೇ ವಿಷನ್ ಮತ್ತು ಫ್ರಾಸ್ಟೆಡ್ ಫಿಲ್ಮ್.",
    price_en: "from ₹35/sq.ft",
    price_kn: "₹35/sq.ft ರಿಂದ",
  },
  {
    id: "sunboard",
    img: IMG.sunboard,
    icon: "SquareStack",
    name_en: "Sun Board",
    name_kn: "ಸನ್ ಬೋರ್ಡ್",
    desc_en: "Rigid 3mm & 5mm PVC foam board displays — direct UV or vinyl mounted for standees & signage.",
    desc_kn: "3mm ಮತ್ತು 5mm PVC ಫೋಮ್ ಬೋರ್ಡ್ ಡಿಸ್‌ಪ್ಲೇ — ಸ್ಟ್ಯಾಂಡೀ ಮತ್ತು ಸೈನೇಜ್.",
    price_en: "from ₹45/sq.ft",
    price_kn: "₹45/sq.ft ರಿಂದ",
  },
  {
    id: "led",
    img: IMG.led,
    icon: "Lightbulb",
    name_en: "LED Name Boards",
    name_kn: "LED ನೇಮ್ ಬೋರ್ಡ್",
    desc_en: "3D acrylic glowing letters & backlit signboards. Waterproof modules with 2-year warranty.",
    desc_kn: "3D ಅಕ್ರಿಲಿಕ್ ಗ್ಲೋಯಿಂಗ್ ಅಕ್ಷರಗಳು ಮತ್ತು ಬ್ಯಾಕ್‌ಲಿಟ್ ಸೈನ್‌ಬೋರ್ಡ್. 2 ವರ್ಷ ವಾರಂಟಿ.",
    price_en: "from ₹120/inch",
    price_kn: "₹120/inch ರಿಂದ",
  },
];

export const FIXED_PRODUCTS = [
  { name_en: "Standard Frontlit Flex Banner", name_kn: "ಸ್ಟ್ಯಾಂಡರ್ಡ್ ಫ್ರಂಟ್‌ಲಿಟ್ ಫ್ಲೆಕ್ಸ್", price: "₹12", unit_en: "per sq.ft · min 20 sq.ft", unit_kn: "ಪ್ರತಿ sq.ft · ಕನಿಷ್ಠ 20", turn_en: "Same day (4 hrs)", turn_kn: "ಅದೇ ದಿನ (4 ಗಂ)" },
  { name_en: "Star Flex High-Gloss Banner", name_kn: "ಸ್ಟಾರ್ ಫ್ಲೆಕ್ಸ್ ಹೈ-ಗ್ಲಾಸ್", price: "₹22", unit_en: "per sq.ft · heavy outdoor", unit_kn: "ಪ್ರತಿ sq.ft · ಔಟ್‌ಡೋರ್", turn_en: "Same day", turn_kn: "ಅದೇ ದಿನ" },
  { name_en: "Self-Adhesive Vinyl Sticker", name_kn: "ಸೆಲ್ಫ್-ಅಡ್ಹೆಸಿವ್ ವಿನೈಲ್", price: "₹35", unit_en: "per sq.ft · matte/gloss", unit_kn: "ಪ್ರತಿ sq.ft · ಮ್ಯಾಟ್/ಗ್ಲಾಸ್", turn_en: "24 hours", turn_kn: "24 ಗಂಟೆ" },
  { name_en: "Roll-up Standee 6×3 ft (with stand)", name_kn: "ರೋಲ್-ಅಪ್ ಸ್ಟ್ಯಾಂಡೀ 6×3 ft", price: "₹1,250", unit_en: "per piece · with bag", unit_kn: "ಪ್ರತಿ ತುಣುಕು · ಬ್ಯಾಗ್ ಸಹಿತ", turn_en: "Same day", turn_kn: "ಅದೇ ದಿನ" },
];

export const CUSTOM_PRODUCTS = [
  { name_en: "3D Acrylic LED Glowing Letters", name_kn: "3D ಅಕ್ರಿಲಿಕ್ LED ಅಕ್ಷರಗಳು", price: "₹120 / inch depth", desc_en: "Custom font cut, waterproof LED modules, 2-year warranty.", desc_kn: "ಕಸ್ಟಮ್ ಫಾಂಟ್, ವಾಟರ್‌ಪ್ರೂಫ್ LED, 2 ವರ್ಷ ವಾರಂಟಿ." },
  { name_en: "Sun Board Display (3mm & 5mm)", name_kn: "ಸನ್ ಬೋರ್ಡ್ ಡಿಸ್‌ಪ್ಲೇ", price: "₹45 / sq.ft", desc_en: "Direct UV or vinyl mounted on rigid PVC foam board.", desc_kn: "ರಿಜಿಡ್ PVC ಫೋಮ್ ಬೋರ್ಡ್ ಮೇಲೆ UV/ವಿನೈಲ್." },
  { name_en: "Backlit Flex Signboard with Frame", name_kn: "ಬ್ಯಾಕ್‌ಲಿಟ್ ಫ್ಲೆಕ್ಸ್ ಸೈನ್‌ಬೋರ್ಡ್", price: "₹85 / sq.ft", desc_en: "Heavy MS tubular frame with internal LED illumination.", desc_kn: "MS ಫ್ರೇಮ್, ಒಳಗಿನ LED ಬೆಳಕು." },
  { name_en: "Storefront Glass & Wall Branding", name_kn: "ಸ್ಟೋರ್‌ಫ್ರಂಟ್ ಗ್ಲಾಸ್ ಬ್ರ್ಯಾಂಡಿಂಗ್", price: "₹50 / sq.ft", desc_en: "One-way vision, frosted film or solid opaque vinyl.", desc_kn: "ಒನ್-ವೇ ವಿಷನ್, ಫ್ರಾಸ್ಟೆಡ್ ಅಥವಾ ಒಪೇಕ್ ವಿನೈಲ್." },
];
